import React, { useState } from 'react';const SalesPart = () => {
  const [activeTab, setActiveTab] = useState('All Leads & Customers');

  const summaryCards = [
    { title: 'TOTAL LEADS', value: '15', subtext: 'All time', valColor: '#0f766e' },
    { title: 'ACTIVE CUSTOMERS', value: '10', subtext: 'Currently Subscribed', valColor: '#111827' },
    { title: 'CONVERSIONS', value: '10', subtext: 'Lead → Customer', valColor: '#111827' },
    { title: 'CONVERSION RATE', value: '67%', subtext: 'Total leads basis', valColor: '#111827' },
    { title: 'REVENUE RECEIVED', value: '₹46K', subtext: 'Paid Invoices', valColor: '#16a34a' },
    { title: 'OVERDUE PAYMENTS', value: '2', subtext: 'Needs follow-up', valColor: '#dc2626' },
  ];

  const tableData = [
    { id: 1, initials: 'AS', name: 'Anjali Singh', company: 'Global Logistics', email: 'anjali@glob.in', phone: '+91 9034512789', source: 'Contact Form', status: 'Converted', active: true, plan: 'Primary', billed: '₹2,000', payment: 'Overdue', bidConv: 'No', lastActivity: '5 days ago' },
    { id: 2, initials: 'DN', name: 'Deepa Nair', company: 'Semiconductors Ltd', email: 'deepa@semi.in', phone: '+91 9876540023', source: 'Website', status: 'Converted', active: true, plan: 'Premium', billed: '₹9,000', payment: 'Paid', bidConv: 'Yes', lastActivity: 'Today' },
    { id: 3, initials: 'KI', name: 'Kavitha Iyer', company: 'PowerGrid Systems', email: 'kavitha@pow.in', phone: '+91 9432109876', source: 'Website', status: 'Converted', active: true, plan: 'Advanced', billed: '₹5,000', payment: 'Paid', bidConv: 'Yes', lastActivity: 'Today' },
    { id: 4, initials: 'KB', name: 'Kiran Bose', company: 'Infra Solutions', email: 'kiran@infra.in', phone: '+91 8987654321', source: 'Social Media', status: 'Contacted', active: false, plan: '—', billed: '—', payment: '—', bidConv: 'No', lastActivity: '3 weeks ago' },
    { id: 5, initials: 'KI', name: 'Kavitha Iyer', company: 'PowerGrid Systems', email: 'kavitha@pow.in', phone: '+91 9432109876', source: 'Website', status: 'Converted', active: true, plan: 'Advanced', billed: '₹5,000', payment: 'Paid', bidConv: 'Yes', lastActivity: 'Today' },
    { id: 6, initials: 'KB', name: 'Kiran Bose', company: 'Infra Solutions', email: 'kiran@infra.in', phone: '+91 8987654321', source: 'Social Media', status: 'Contacted', active: false, plan: '—', billed: '—', payment: '—', bidConv: 'No', lastActivity: '3 weeks ago' },
    { id: 7, initials: 'AS', name: 'Anjali Singh', company: 'Global Logistics', email: 'anjali@glob.in', phone: '+91 9034512789', source: 'Contact Form', status: 'Converted', active: true, plan: 'Primary', billed: '₹2,000', payment: 'Overdue', bidConv: 'No', lastActivity: '5 days ago' },
  ];

  const billingData = [
    { id: 'INV-001', name: 'Mathew Scott', company: 'ABC Technologies', plan: 'Premium', period: '01/03/2026 – 01/03/2027', amount: '₹8,000', status: 'Paid', invoiceDate: '01/03/2026', dueDate: '15/03/2026', bidConverted: 'Yes', overdue: false },
    { id: 'INV-002', name: 'Priya Sharma', company: 'BuildPro Solutions', plan: 'Advanced', period: '15/02/2026 – 15/02/2027', amount: '₹5,000', status: 'Paid', invoiceDate: '15/02/2026', dueDate: '01/03/2026', bidConverted: 'Yes', overdue: false },
    { id: 'INV-003', name: 'Rahul Mehta', company: 'TechCorp Ltd', plan: 'Premium', period: '10/01/2026 – 10/01/2027', amount: '₹8,000', status: 'Paid', invoiceDate: '10/01/2026', dueDate: '25/01/2026', bidConverted: 'Yes', overdue: false },
    { id: 'INV-004', name: 'Anjali Singh', company: 'Global Logistics', plan: 'Primary', period: '05/02/2026 – 05/02/2027', amount: '₹2,000', status: 'Overdue', invoiceDate: '05/02/2026', dueDate: '20/02/2026', bidConverted: 'No', overdue: true },
    { id: 'INV-005', name: 'Deepa Nair', company: 'Semiconductors Ltd', plan: 'Premium', period: '20/01/2026 – 20/01/2027', amount: '₹8,000', status: 'Paid', invoiceDate: '20/01/2026', dueDate: '05/02/2026', bidConverted: 'Yes', overdue: false },
    { id: 'INV-006', name: 'Suresh Kumar', company: 'InnovateTech', plan: 'Advanced', period: '12/02/2026 – 12/02/2027', amount: '₹5,000', status: 'Paid', invoiceDate: '12/02/2026', dueDate: '28/02/2026', bidConverted: 'Yes', overdue: false },
    { id: 'INV-007', name: 'Kavitha Iyer', company: 'PowerGrid Systems', plan: 'Advanced', period: '08/03/2026 – 08/03/2027', amount: '₹5,000', status: 'Paid', invoiceDate: '08/03/2026', dueDate: '23/03/2026', bidConverted: 'Yes', overdue: false },
    { id: 'INV-008', name: 'Rajesh Gupta', company: 'CyberShield India', plan: 'Premium', period: '25/01/2026 – 25/01/2027', amount: '₹8,000', status: 'Overdue', invoiceDate: '25/01/2026', dueDate: '10/02/2026', bidConverted: 'Yes', overdue: true },
    { id: 'INV-009', name: 'Sita Krishnan', company: 'GreenEnergy Ltd', plan: 'Advanced', period: '18/02/2026 – 18/02/2027', amount: '₹5,000', status: 'Paid', invoiceDate: '18/02/2026', dueDate: '05/03/2026', bidConverted: 'No', overdue: false },
    { id: 'INV-010', name: 'Divya Menon', company: 'SkyBuild Corp', plan: 'Primary', period: '01/03/2026 – 01/03/2027', amount: '₹2,000', status: 'Paid', invoiceDate: '01/03/2026', dueDate: '16/03/2026', bidConverted: 'Yes', overdue: false },
  ];

  // ── AVATAR COLOR MAP ──
  const getAvatarStyle = (initials) => {
    const map = {
      'AS': { bg: '#fde68a', color: '#92400e' },
      'DN': { bg: '#bfdbfe', color: '#1e40af' },
      'KI': { bg: '#a7f3d0', color: '#065f46' },
      'KB': { bg: '#ddd6fe', color: '#5b21b6' },
    };
    return map[initials] || { bg: '#e5e7eb', color: '#374151' };
  };

  // ── RENDERERS ──
  const renderSource = (source) => {
    let color = '#2563eb';
    if (source === 'Contact Form') color = '#d97706';
    if (source === 'Social Media') color = '#7e22ce';
    return <span style={{ color, fontWeight: '600', fontSize: '0.8rem' }}>{source}</span>;
  };

  const renderStatus = (status) => {
    if (status === 'Converted') {
      return <span style={{ backgroundColor: '#dcfce7', color: '#166534', padding: '0.35rem 1.1rem', fontWeight: '600', fontSize: '0.72rem', borderRadius: '50px', display: 'inline-block' }}>Converted</span>;
    }
    return <span style={{ backgroundColor: '#dbeafe', color: '#1d4ed8', padding: '0.35rem 1.1rem', fontWeight: '600', fontSize: '0.72rem', borderRadius: '50px', display: 'inline-block', border: '1px solid #93c5fd' }}>Contacted</span>;
  };

  const renderActive = (isActive) => {
    const color = isActive ? '#16a34a' : '#9ca3af';
    const text = isActive ? 'Active' : 'Inactive';
    return (
      <div className="d-flex align-items-center justify-content-center gap-1">
        <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: color, flexShrink: 0 }}></div>
        <span style={{ color, fontWeight: '600', fontSize: '0.8rem' }}>{text}</span>
      </div>
    );
  };

  const renderPlan = (plan) => {
    if (plan === '—') return <span style={{ color: '#9ca3af' }}>—</span>;
    let bg = '#ccfbf1', color = '#0f766e';
    if (plan === 'Premium') { bg = '#f3e8ff'; color = '#7e22ce'; }
    else if (plan === 'Advanced') { bg = '#e0f2fe'; color = '#0369a1'; }
    return <span style={{ backgroundColor: bg, color, padding: '0.35rem 1.1rem', fontWeight: '600', fontSize: '0.72rem', borderRadius: '50px', display: 'inline-block' }}>{plan}</span>;
  };

  const renderPayment = (payment) => {
    if (payment === '—') return <span style={{ color: '#9ca3af' }}>—</span>;
    if (payment === 'Overdue') return <span style={{ backgroundColor: '#fee2e2', color: '#991b1b', padding: '0.35rem 1.1rem', fontWeight: '600', fontSize: '0.72rem', borderRadius: '50px', display: 'inline-block' }}>Overdue</span>;
    return <span style={{ backgroundColor: '#dcfce7', color: '#166534', padding: '0.35rem 1.1rem', fontWeight: '600', fontSize: '0.72rem', borderRadius: '50px', display: 'inline-block' }}>Paid</span>;
  };

  const renderBidConv = (conv) => {
    if (conv === 'Yes') return <span style={{ color: '#16a34a', fontWeight: '600', fontSize: '0.8rem' }}>Yes</span>;
    return <span style={{ color: '#6b7280', fontWeight: '500', fontSize: '0.8rem' }}>No</span>;
  };

  return (
    <div className="container-fluid py-4" style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>

      {/* ── TOP HEADER ── */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h3 style={{ fontWeight: '700', color: '#111827', margin: 0 }}>Sales Portal</h3>
          <p style={{ color: '#6b7280', fontSize: '0.85rem', margin: '4px 0 0 0' }}>Track leads, activity status, billing, conversions and source — all in one place</p>
        </div>
        <div className="d-flex gap-3 align-items-center">
          <div className="d-flex gap-2">
            {['1mo', '3mo', '1yr'].map(f => (
              <button key={f} className="btn btn-sm shadow-none" style={{
                borderRadius: '50px', fontSize: '0.8rem', fontWeight: '600', padding: '5px 16px',
                border: f === '3mo' ? '2px solid #0f766e' : '1.5px solid #e0e0e0',
                background: f === '3mo' ? '#ccfbf1' : '#fff',
                color: f === '3mo' ? '#0f766e' : '#6b7280',
              }}>{f}</button>
            ))}
          </div>
          <button className="btn btn-sm shadow-none d-flex align-items-center gap-2" style={{ backgroundColor: '#0f766e', color: 'white', borderRadius: '8px', padding: '0.4rem 1rem', fontWeight: '600', fontSize: '0.8rem' }}>
            ↓ Download Report
          </button>
        </div>
      </div>

      {/* ── SUMMARY CARDS ── */}
      <div className="row g-3 mb-4">
        {summaryCards.map((card, idx) => (
          <div className="col" key={idx} style={{ minWidth: '16%' }}>
            <div className="card h-100 bg-white p-3" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
              <h6 className="mb-3 text-uppercase" style={{ fontSize: '0.65rem', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em' }}>{card.title}</h6>
              <h3 className="mb-2" style={{ fontWeight: '700', color: card.valColor, fontSize: '1.6rem' }}>{card.value}</h3>
              <p className="mb-0" style={{ fontSize: '0.75rem', color: '#6b7280' }}>{card.subtext}</p>
            </div>
          </div>
        ))}
      </div>

      {/* ── TABS ── */}
      <div className="d-flex gap-4 mb-4" style={{ borderBottom: '1px solid #e5e7eb' }}>
        {['All Leads & Customers', 'Billing Table'].map(tab => (
          <div
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              paddingBottom: '10px',
              borderBottom: activeTab === tab ? '2px solid #0f766e' : '2px solid transparent',
              color: activeTab === tab ? '#0f766e' : '#6b7280',
              fontWeight: activeTab === tab ? '600' : '500',
              fontSize: '0.9rem',
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
          >{tab}</div>
        ))}
      </div>

      {/* ══════════════════════════════════════════════
          TAB 1 — ALL LEADS & CUSTOMERS
      ══════════════════════════════════════════════ */}
      {activeTab === 'All Leads & Customers' && (
        <>
          {/* Filters */}
          <div className="card bg-white p-3 mb-4" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 style={{ fontWeight: '700', color: '#111827', margin: 0, fontSize: '0.9rem' }}>Filters</h6>
              <div className="d-flex gap-2">
                <span style={{ backgroundColor: '#ccfbf1', color: '#0f766e', padding: '0.4rem 0.8rem', fontWeight: '600', fontSize: '0.75rem', borderRadius: '16px' }}>15 records</span>
                <button className="btn btn-sm shadow-none" style={{ border: '1px solid #fca5a5', color: '#dc2626', backgroundColor: '#fff', fontSize: '0.75rem', fontWeight: '600', borderRadius: '16px', padding: '0.2rem 1rem' }}>Reset</button>
              </div>
            </div>
            <div className="row g-2">
              <div className="col-lg-3 col-md-12">
                <label style={{ fontSize: '0.65rem', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em', marginBottom: '4px' }}>SEARCH</label>
                <input type="text" className="form-control shadow-none" placeholder="Name, company, email..." style={{ border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '0.8rem', height: '36px', color: '#4b5563' }} />
              </div>
              {['CLASSIFICATION', 'LEAD STATUS', 'SOURCE', 'PLAN', 'BILLING', 'ACTIVE?', 'BID CONVERTED?'].map((label, idx) => (
                <div className="col" key={idx} style={{ minWidth: '110px' }}>
                  <label style={{ fontSize: '0.65rem', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em', marginBottom: '4px' }}>{label}</label>
                  <select className="form-select shadow-none" style={{ border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '0.8rem', height: '36px', color: '#4b5563', cursor: 'pointer' }}>
                    <option>All</option>
                  </select>
                </div>
              ))}
            </div>
          </div>

          {/* Leads Table */}
          <div className="card bg-white" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
            <div className="d-flex justify-content-between align-items-center p-3" style={{ borderBottom: '1px solid #f3f4f6' }}>
              <h6 className="fw-bold mb-0" style={{ color: '#111827', fontSize: '0.9rem' }}>Leads & Customer Details (15)</h6>
              <button className="btn btn-sm shadow-none" style={{ backgroundColor: '#0f766e', color: 'white', fontSize: '0.75rem', fontWeight: '600', borderRadius: '16px', padding: '0.3rem 1rem' }}>Export CSV</button>
            </div>
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
                <thead>
                  <tr style={{ color: '#6b7280', fontSize: '0.65rem', fontWeight: '700', letterSpacing: '0.05em', borderBottom: '1px solid #e5e7eb', backgroundColor: '#f9fafb' }}>
                    <th className="py-2 px-3 border-bottom-0">NAME / COMPANY ▲</th>
                    <th className="py-2 border-bottom-0">CONTACT</th>
                    <th className="py-2 border-bottom-0 text-center">SOURCE ⇅</th>
                    <th className="py-2 border-bottom-0 text-center">LEAD STATUS ⇅</th>
                    <th className="py-2 border-bottom-0 text-center">ACTIVE? ⇅</th>
                    <th className="py-2 border-bottom-0 text-center">PLAN ⇅</th>
                    <th className="py-2 border-bottom-0 text-center">BILLED AMOUNT ⇅</th>
                    <th className="py-2 border-bottom-0 text-center">PAYMENT ⇅</th>
                    <th className="py-2 border-bottom-0 text-center">BID CONVERTED? ⇅</th>
                    <th className="py-2 border-bottom-0 text-center">LAST ACTIVITY ⇅</th>
                <th className="py-2 border-bottom-0">ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => {
                    const avatarStyle = getAvatarStyle(row.initials);
                    return (
                      <tr key={index} style={{ borderBottom: '1px solid #f3f4f6', lineHeight: '1.3' }}>
                        <td className="px-3 py-1">
                          <div className="d-flex align-items-center gap-2">
                            <div className="rounded-circle d-flex justify-content-center align-items-center flex-shrink-0" style={{ width: '30px', height: '30px', backgroundColor: avatarStyle.bg, color: avatarStyle.color, fontSize: '0.65rem', fontWeight: '700' }}>
                              {row.initials}
                            </div>
                            <div>
                              <div style={{ fontWeight: '700', color: '#111827', fontSize: '0.8rem' }}>{row.name}</div>
                              <div style={{ color: '#6b7280', fontSize: '0.7rem' }}>{row.company}</div>
                            </div>
                          </div>
                        </td>
                        <td className="py-1">
                          <div style={{ color: '#6b7280', fontSize: '0.72rem' }}>{row.email}</div>
                          <div style={{ fontWeight: '600', color: '#111827', fontSize: '0.72rem' }}>{row.phone}</div>
                        </td>
                        <td className="py-1 text-center">{renderSource(row.source)}</td>
                        <td className="py-1 text-center">{renderStatus(row.status)}</td>
                        <td className="py-1 text-center">{renderActive(row.active)}</td>
                        <td className="py-1 text-center">{renderPlan(row.plan)}</td>
                        <td className="py-1 text-center" style={{ fontWeight: '700', color: '#111827', fontSize: '0.8rem' }}>{row.billed}</td>
                        <td className="py-1 text-center">{renderPayment(row.payment)}</td>
                        <td className="py-1 text-center">{renderBidConv(row.bidConv)}</td>
                        <td className="py-1 text-center" style={{ color: '#6b7280', fontSize: '0.75rem' }}>{row.lastActivity}</td>
                        <td className="py-1 text-center">
                          <div className="d-flex gap-1 justify-content-center">
                            <button className="btn btn-sm shadow-none" style={{ backgroundColor: '#ccfbf1', color: '#0f766e', fontSize: '0.68rem', fontWeight: '600', padding: '0.2rem 0.65rem', borderRadius: '6px' }}>View</button>
                            <button className="btn btn-sm shadow-none" style={{ backgroundColor: '#dbeafe', color: '#1d4ed8', fontSize: '0.68rem', fontWeight: '600', padding: '0.2rem 0.65rem', borderRadius: '6px' }}>Email</button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between align-items-center p-3" style={{ borderTop: '1px solid #f3f4f6' }}>
              <span style={{ color: '#6b7280', fontSize: '0.75rem' }}>Showing 15 of 15 records</span>
              <div className="d-flex gap-1">
                <button className="btn btn-sm shadow-none" style={{ backgroundColor: '#0f766e', color: 'white', border: '1px solid #0f766e', fontSize: '0.75rem', fontWeight: '600', width: '30px' }}>1</button>
                <button className="btn btn-sm bg-white shadow-none" style={{ border: '1px solid #e5e7eb', color: '#4b5563', fontSize: '0.75rem', width: '30px' }}>2</button>
                <button className="btn btn-sm bg-white shadow-none" style={{ border: '1px solid #e5e7eb', color: '#4b5563', fontSize: '0.75rem', width: '30px' }}>3</button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ══════════════════════════════════════════════
          TAB 2 — BILLING TABLE
      ══════════════════════════════════════════════ */}
      {activeTab === 'Billing Table' && (
        <>
          {/* Billing Summary Cards */}
          <div className="row g-3 mb-4">
            {[
              { title: 'TOTAL INVOICES', value: '10', valColor: '#111827' },
              { title: 'TOTAL COLLECTED', value: '₹46K', valColor: '#0f766e' },
              { title: 'OVERDUE AMOUNT', value: '₹10K', valColor: '#dc2626' },
              { title: 'AVG INVOICE', value: '₹5.8K', valColor: '#111827' },
            ].map((card, idx) => (
              <div className="col" key={idx}>
                <div className="card bg-white p-3" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
                  <div style={{ fontSize: '0.65rem', fontWeight: '700', color: '#6b7280', textTransform: 'none', letterSpacing: '0.05em', marginBottom: '10px' }}>{card.title}</div>
                  <div style={{ fontSize: '1.8rem', fontWeight: '700', color: card.valColor }}>{card.value}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Billing Filters */}
          <div className="card bg-white p-3 mb-4" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
            <div className="d-flex gap-3 align-items-end flex-wrap">
              {[
                { label: 'CUSTOMER', placeholder: 'All', type: 'select' },
                { label: 'BILLING STATUS', placeholder: 'All', type: 'select' },
                { label: 'PLAN', placeholder: 'All', type: 'select' },
              ].map((f, idx) => (
                <div key={idx} style={{ minWidth: '120px' }}>
                  <label style={{ fontSize: '0.65rem', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em', marginBottom: '4px', display: 'block' }}>{f.label}</label>
                  <select className="form-select shadow-none" style={{ border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '0.8rem', height: '36px', color: '#4b5563', cursor: 'pointer', minWidth: '120px' }}>
                    <option>All</option>
                  </select>
                </div>
              ))}
              <div style={{ minWidth: '130px' }}>
                <label style={{ fontSize: '0.65rem', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em', marginBottom: '4px', display: 'block' }}>START</label>
                <input type="text" placeholder="dd/mm/yy" className="form-control shadow-none" style={{ border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '0.8rem', height: '36px', color: '#9ca3af' }} />
              </div>
              <div style={{ minWidth: '130px' }}>
                <label style={{ fontSize: '0.65rem', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em', marginBottom: '4px', display: 'block' }}>END</label>
                <input type="text" placeholder="dd/mm/yy" className="form-control shadow-none" style={{ border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '0.8rem', height: '36px', color: '#9ca3af' }} />
              </div>
            </div>
          </div>

          {/* Billing Records Table */}
          <div className="card bg-white" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
            <div className="d-flex justify-content-between align-items-center p-3" style={{ borderBottom: '1px solid #f3f4f6' }}>
              <h6 className="fw-bold mb-0" style={{ color: '#111827', fontSize: '0.9rem' }}>Billing Records</h6>
              <button className="btn btn-sm shadow-none" style={{ backgroundColor: '#0f766e', color: 'white', fontSize: '0.75rem', fontWeight: '600', borderRadius: '8px', padding: '0.3rem 1rem' }}>Export</button>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
                <thead>
                  <tr style={{ color: '#6b7280', fontSize: '0.65rem', fontWeight: '700', letterSpacing: '0.05em', borderBottom: '1px solid #e5e7eb' }}>
                    <th className="py-2 px-3 border-bottom-0">INVOICE ID</th>
                    <th className="py-2 border-bottom-0">CUSTOMER</th>
                    <th className="py-2 border-bottom-0">COMPANY</th>
                    <th className="py-2 border-bottom-0">PLAN</th>
                    <th className="py-2 border-bottom-0">BILLING PERIOD</th>
                    <th className="py-2 border-bottom-0 text-center">AMOUNT</th>
                    <th className="py-2 border-bottom-0 text-center">STATUS</th>
                    <th className="py-2 border-bottom-0 text-center">INVOICE DATE</th>
                    <th className="py-2 border-bottom-0 text-center">DUE DATE</th>
                    <th className="py-2 border-bottom-0 text-center">BID CONVERTED</th>
                 <th className="py-2 border-bottom-0">ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {billingData.map((row, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid #f3f4f6', lineHeight: '1.3' }}>
                      <td className="px-3 py-2" style={{ color: '#6b7280', fontSize: '0.78rem', fontWeight: '500' }}>{row.id}</td>
                      <td className="py-2" style={{ fontWeight: '700', color: '#111827', fontSize: '0.8rem' }}>{row.name}</td>
                      <td className="py-2" style={{ color: '#6b7280', fontSize: '0.78rem' }}>{row.company}</td>
                      <td className="py-2">{renderPlan(row.plan)}</td>
                      <td className="py-2" style={{ color: '#6b7280', fontSize: '0.78rem' }}>{row.period}</td>
                      <td className="py-2 text-center" style={{ fontWeight: '700', color: '#111827', fontSize: '0.8rem' }}>{row.amount}</td>
                      <td className="py-2 text-center">{renderPayment(row.status)}</td>
                      <td className="py-2 text-center" style={{ color: '#6b7280', fontSize: '0.78rem' }}>{row.invoiceDate}</td>
                      <td className="py-2 text-center" style={{ fontWeight: row.overdue ? '700' : '400', color: row.overdue ? '#dc2626' : '#6b7280', fontSize: '0.78rem' }}>{row.dueDate}</td>
                      <td className="py-2 text-center">{renderBidConv(row.bidConverted)}</td>
<td className="py-2 px-3">
  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
    <button className="btn btn-sm shadow-none" style={{ backgroundColor: '#ccfbf1', color: '#0f766e', fontSize: '0.72rem', fontWeight: '600', padding: '0.25rem 0.8rem', borderRadius: '6px', whiteSpace: 'nowrap' }}>View</button>
    {row.overdue && (
      <button className="btn btn-sm shadow-none" style={{ backgroundColor: '#fee2e2', color: '#dc2626', fontSize: '0.72rem', fontWeight: '600', padding: '0.25rem 0.8rem', borderRadius: '6px', whiteSpace: 'nowrap' }}>Remind</button>
    )}
  </div>
</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Footer */}
            <div className="d-flex justify-content-between align-items-center p-3" style={{ borderTop: '1px solid #f3f4f6' }}>
              <span style={{ color: '#6b7280', fontSize: '0.75rem' }}>Showing 10 Invoices</span>
              <span style={{ color: '#0f766e', fontSize: '0.8rem', fontWeight: '700' }}>Total Collected: ₹46,000</span>
            </div>
          </div>
        </>
      )}

    </div>
  );
};

export default SalesPart;